import { MINUTE, type SourceDefinition } from '../types';

export const config = {
  id: 'vitals',
  kind: 'gcs',
  url: 'https://storage.googleapis.com/life-sync-bucket/vitals.json',
  refetchMiliseconds: 5 * MINUTE,
  staleAfterMiliseconds: 30 * MINUTE,
  preload: 'fetch',
} satisfies SourceDefinition;
